import { useState, useCallback } from 'react';

import { Filter } from '../../Filters.types';
import { QueryParam } from '~/common/types';

interface UseFilterSharePopoverResult {
  url?: string;
  onClose: () => void;
  onFilterShare: (filter: Filter) => void;
}

export const useFilterSharePopover = (): UseFilterSharePopoverResult => {
  const [shareLink, setShareLink] = useState<string | undefined>(undefined);

  const onFilterShare = useCallback((filter: Filter) => {
    const url = window.location.search
      ? window.location.href.replace(window.location.search, `?${QueryParam.QUERY}=${filter.queryId}`)
      : `${window.location.href}?${QueryParam.QUERY}=${filter.queryId}`;
    setShareLink(url);
  }, []);

  const onClose = useCallback(() => {
    setShareLink(undefined);
  }, []);

  return {
    url: shareLink,
    onFilterShare,
    onClose,
  };
};
